import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from '../../enums/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {

      constructor(private httpService: HttpService) { }

      async getKits(cpf:any){
          return new Promise((resolve, reject) => {
              try {

                  let config = this.httpService.setHeaderConfig(true);
                  let body = {
                    cpf: cpf
                  }

                  this.httpService.get(UrlConnectionEnum.GET_LIST_KIT, body, config).subscribe({
                      next: (data) => {
                          if(data.result){
                              resolve(data.result);
                          }else{
                            resolve(data)
                          }
                      },
                      error: (error) => {
                          reject(error);
                      }
                  });

              } catch (error) {
                  reject(error);
              }
          });
      }

      async updateKit(kit:any){
          return new Promise((resolve, reject) => {
              try {

                  let config = this.httpService.setHeaderConfig(true);
                  let body = kit;

                  this.httpService.put(UrlConnectionEnum.UPDATE_KIT, body, config).subscribe({
                      next: (data) => {
                          if(data.result){
                              resolve(data.result);
                          }else{
                            resolve(data)
                          }
                      },
                      error: (error) => {
                          reject(error);
                      }
                  });

              } catch (error) {
                  reject(error);
              }
          });
      }


          async createKit(payload:any){
          return new Promise((resolve, reject) => {
              try {

                  let config = this.httpService.setHeaderConfig(true);
                  this.httpService.post(UrlConnectionEnum.CREATE_KIT, payload, config).subscribe({
                      next: (data) => {
                          if(data.result){
                              resolve(data.result);
                          }else{
                            resolve(data)
                          }
                      },
                      error: (error) => {
                          reject(error);
                      }
                  });

              } catch (error) {
                  reject(error);
              }
          });
      }

}
